import { TypeHelper } from '../../helpers'
import { OpDescr } from '../core'

export class OpAvailableExternalDevicePattern {
	public descr: OpDescr
	public name: string
	public idFile: number

	constructor(opObj: any = null) {
		if (opObj) {
			this.name = opObj.Name
			this.idFile = opObj.IdFile
			if (opObj.Descr != null) {
				this.descr = new OpDescr(opObj.Descr)
			}
		}
	}

	public toString(): string {
		if (this.descr != null) {
			return this.descr.toString()
		}

		return this.name || TypeHelper.emptyString
	}
}
